document.addEventListener("moved", (event) => {
	if (event.target.matches(".vermoegenswert_anlageklasse_index")) {
		const formContainer = event.target.closest("form")

		updateLiquidierungsrang(formContainer)
	}
})

const updateLiquidierungsrang = (formContainer) => {
	if (formContainer) {
		const anlageklassen = formContainer.querySelectorAll(".vermoegenswert_anlageklasse")

		anlageklassen.forEach((anlageklasse, index) => {
			const inputLiquidierungsrang = anlageklasse.querySelector(".liquidierungsrang")
			inputLiquidierungsrang.value = index
		})
	}
}
